import React from 'react';

const Quotes = () => (
  <div>
    <div className="quotes">
      <h3>
        Mathematics is not about numbers, equations, computations, or algorithms.
        <br />
        It is about understanding. -William Paul Thurston.
      </h3>
    </div>
  </div>
);

export default Quotes;
